import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { FareRulesQuery } from '@websky/graphql';

interface Props {
	passengersRules?: FareRulesQuery['FareRules']['rulesForSegments'];
}

export const FareCode: React.FC<Props> = ({ passengersRules }) => {
	const { t } = useTranslation('FareConditions');

	if (!passengersRules?.length) {
		return null;
	}

	const codes = passengersRules.reduce((acc, passengerRules) => {
		if (passengerRules?.rules?.[0]?.fareCode) {
			acc.push(passengerRules.rules[0].fareCode);
		}

		return acc;
	}, []);

	return (
		<>
			{t('Fare code')}: {codes.join(', ')}
		</>
	);
};

export default FareCode;
